import { getActuralApi } from './utils';

// 搜索记录接口
export const searchHistory = getActuralApi(`/jstore/V1/visitlog/classified/list`);
// 清除记录接口
export const deleteHistory = getActuralApi(`/jstore/V1/visitlog/delete`);
// 企业搜索接口
export const searchCompany = getActuralApi(`/app/v1/search/company_query`);
// 求职调查接口
export const getReport = getActuralApi(`/app/v1/homepage/job_seek_report/get_report`);
// 求职调查首页卡片
export const jobSeekReportBanner = getActuralApi('/app/v1/job_seek_report/banner')
// 求职调查劳动纠纷企业列表
export const judgInstCompanyList = getActuralApi('/app/v1/job_seek_report/judg_inst_company_list')
// 求职调查劳动纠纷企业纠纷列表
export const judgInstList = getActuralApi('/app/v1/job_seek_report/judg_inst_list')